import type { ColumnDef, OnChangeFn, Row, SortingState } from "@tanstack/react-table"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC, RefObject } from "react"
import type { CombinedError } from "urql"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { PriceChangeSubmission } from "@/graphql/codegen/graphql"

interface PriceChangeHistoryTableProps {
  data: PriceChangeSubmission[]
  loading?: boolean
  error?: CombinedError | Error
  sorting: SortingState
  columns: ColumnDef<PriceChangeSubmission>[]
  containerRef?: RefObject<HTMLDivElement>
  onSortingChange: OnChangeFn<SortingState>
  onScroll?: () => void
  onRowClick?: (submissionId: string) => void
}

export const PriceChangeHistoryTable: FC<PriceChangeHistoryTableProps> = ({
  data,
  error,
  loading = false,
  sorting,
  containerRef,
  columns,
  onSortingChange,
  onScroll,
  onRowClick,
}) => {
  const handleRowClick = (row: Row<PriceChangeSubmission>) => {
    onRowClick?.(row.original.id)
  }

  return (
    <AerosBaseTable
      error={error}
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data,
          columns,
          state: {
            sorting,
            isLoading: loading,
          },
          manualSorting: true,
          enableSorting: true,
          enableMultiSort: false,
          enableSortingRemoval: false,
          getCoreRowModel: getCoreRowModel(),
          onSortingChange,
        },
      }}
      slotProps={{
        bodyRow: {
          className: "hover:bg-primary-100 cursor-pointer",
          onClick: (value) => handleRowClick(value as Row<PriceChangeSubmission>),
        },
        container: { ref: containerRef, onScroll },
      }}
      noDataMessage='No price change history found'
    />
  )
}
